module.exports = __webpack_public_path__ + "img/B低通锐化5.41886c54.png";